import React from 'react'
import Wadhead from './Wadhead/Wadhead'
import Wwo from './Wwo/Wwo'
import Wgbs from './Wgbs/Wgbs'
import Wcdw from './Wcdw/Wcdw'
import WhyHIreUs from './WhyHireUs/WhyHIreUs'

function MobileApplicationDevelopment() {
  return (
    <>
      <Wadhead/>
      <WhyHIreUs/>
      <Wwo />
      <Wcdw />
      <Wgbs />
    </>
  )
}

export default MobileApplicationDevelopment
